// extracted by mini-css-extract-plugin
module.exports = {"contacts":"Contacts_contacts__UmhgK","contacts-title":"Contacts_contacts-title__NGm7q","contacts-address":"Contacts_contacts-address__Qa7N8"};